import { makeStyles } from '@material-ui/core/styles';
import { Field, FieldArray } from 'redux-form';
export const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%'
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
  },
  currencyField: {
    width: '147px !important',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      marginBottom: '10px'
    },
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    color: '#182e3d',
    [theme.breakpoints.down('sm')]: {
      marginTop: '10px'
    },
  },
  dropDownField: {
    marginBottom: '18px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
  },
  buttonsGroup: {
    width: '195px',
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
  },
  deleteIcon: {
    fontSize: '23px',
    color: '#59758B'
  },
  deleteBtn: {
    height: '36px',
    padding: '0',
    marginTop: '18px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '10px'
    },
  },
  category: {
    paddingBottom: '25px',
    marginBottom: '25px',
    borderBottom: '1px solid #e2ebf6',
    '&:last-child': {
      paddingBottom: '0',
      marginBottom: '0',
      border: '0'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }
}));

